import { atom } from 'recoil';
import { STORE_KEYS } from 'store/keys';
import { WalletResponse } from 'TYPES/api.body';

interface CheckoutVariables {
  checkoutLoading: boolean;
  deliveryOccurrence?: string;
  pointsUsed: Omit<WalletResponse, 'balance' | 'id'>;
  selectedCarrier?: any;
  request_token?: any;
  driverNote?: string;
}

const checkoutVariablesAtom = atom<CheckoutVariables>({
  key: STORE_KEYS.CHECKOUT_VARIABLES,
  default: {
    checkoutLoading: false,
    deliveryOccurrence: 'None',
    pointsUsed: { pointNairaEquivalent: 0, points: 0 },
    request_token: '',
    driverNote: ''
  }
});

export default checkoutVariablesAtom;
